import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/axiosConfig';

const SiteContext = createContext();

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within a SiteProvider');
  }
  return context;
};

export const SiteProvider = ({ children }) => {
  const [siteConfig, setSiteConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const SITE_ID = process.env.REACT_APP_SITE_ID;

  useEffect(() => {
    const fetchSiteConfig = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('Fetching site config for site ID:', SITE_ID);
        
        // Try to fetch site configuration
        const response = await api.get(`/sites/${SITE_ID}`);
        
        if (response.data.success) {
          setSiteConfig(response.data.data);
          console.log('Site config loaded successfully');
        } else {
          setError(response.data.message || 'Failed to load site configuration');
        }
      } catch (err) {
        console.error('Error fetching site config:', err);
        setError('Unable to load site data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (SITE_ID) {
      fetchSiteConfig();
    } else {
      setError('Site ID is not configured.');
      setLoading(false);
    }
  }, [SITE_ID]);

  const value = {
    siteConfig,
    loading,
    error,
    siteId: SITE_ID
  };

  return (
    <SiteContext.Provider value={value}>
      {children}
    </SiteContext.Provider>
  );
};